// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__x00v3","links":"Footer_links__61J+y","text":"Footer_text__6sArP","gitlinks":"Footer_gitlinks__70-Lf"};